import React from "react";
import MyTimesheet from "../components/MyTimesheet";

export const TimeCards = () => {
  return (
    <div className="timesheet">
      {/* <div className="options">
        <h2 className="title">My Timesheets</h2>{" "}
        <SideDropDownOptions crewUserId={id ? id : user_id} />
      </div> */}
      <MyTimesheet
      />{" "}
      {/* <div className="text-end">
        <button className="primary-btn save-btn">Save</button>
      </div> */}
    </div>
  );
};

export default TimeCards;
